import { ButtonBase, SxProps, Theme } from '@mui/material';
import React from 'react';

import { Typography } from '@ocx/ui';

type CategoryPillProps = {
  onClick: () => void;
  isSelected: boolean;
  children: React.ReactNode;
  sx?: SxProps<Theme>;
};

const HORIZONTAL_SPACING = 1.25;
const VERTICAL_SPACING = 0.75;
const CATEGORY_BUTTON_HEIGHT = 32;

export const CategoryPill = ({ onClick, isSelected, children, sx }: CategoryPillProps) => {
  return (
    <ButtonBase
      onClick={onClick}
      sx={{
        height: CATEGORY_BUTTON_HEIGHT,
        py: VERTICAL_SPACING,
        px: HORIZONTAL_SPACING,
        borderRadius: CATEGORY_BUTTON_HEIGHT / 2,
        whiteSpace: 'nowrap',
        backgroundColor: (theme) => (isSelected ? theme.palette.primary.main : theme.palette.common.white),
        color: (theme) => (isSelected ? theme.palette.common.white : theme.palette.text.secondary),
        ...(sx || {}),
      }}>
      <Typography variant="body2">{children}</Typography>
    </ButtonBase>
  );
};
